import React, { PropTypes } from 'react';
import './Gender.scss';

const GENDERS = ['male', 'female', 'other', 'n/a'];

class Gender extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.props.onChange(e.target.value, GENDERS.indexOf(e.target.value));
  }

  render() {

    const {
      value,
      label,
      className,
    } = this.props;
    return (
      <div className={'row gender-radio ' + className}>
        <div className='col-xs-4'>
          <div className='radio'>
            <label className='control'>
              <input type="radio" value='male' onChange={this.onChange} checked={value === 'male' || value === 0 } />
              <span className='radiomark'></span>
              <span className='radio-gender'>{__('Male', 'teacher')}</span>
            </label>
          </div>
        </div>
        <div className='col-xs-4'>
          <div className='radio'>
            <label className='control'>
            <input
              type="radio"
              value='female'
              onChange={this.onChange}
              checked={value === 'female' || value === 1}
            />
            <span className='radiomark'></span>
              <span className='radio-gender'>{__('Female', 'teacher')}</span>
            </label>
          </div>
        </div>
        <div className='col-xs-4'>
          <div className='radio'>
            <label className='control'>
            <input
              type="radio"
              value='n/a'
              onChange={this.onChange}
              checked={value === 'n/a' || value === 3}
            />
            <span className='radiomark'></span>
              <span className='radio-gender'>{__('N/A', 'teacher')}</span>
            </label>
          </div>
        </div>
      </div>

    );
  }
}

export default Gender;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/Gender/index.js